import * as React from "react";
import { forwardRef } from "react";
const SvgCheckThick = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M70.621 20.713 38.676 66.568 24.984 54.395c-3.069-2.73-7.86-2.447-10.59.623-2.727 3.069-2.445 7.859.624 10.587l19.998 17.782c3.318 2.95 8.596 2.328 9.866.506l39.22-56.29c1.174-1.686.4-6.516-3.041-8.755-3.52-2.29-8.094-1.502-10.44 1.865" />
  </svg>
);
const ForwardRef = forwardRef(SvgCheckThick);
export default ForwardRef;
